
<!-- Login form -->
<div *ngIf="formMode==formModeType.Login" class="login-form">

    <div class="text-center mb-3">
      <h1>{{ 'WelcomeBack' | translate }}</h1>
    </div>

    <form [formGroup]="loginForm" class="login-container text-left" (ngSubmit)="login()">


      <div *ngIf="!formControls.email.valid && !formControls.password.valid && (formControls.email.errors.Invalid || formControls.password.errors.Invalid)">Username or password is incorrect !!</div>
      <div *ngIf="isSubmitted && loginForm.invalid" class="required">
        <div class="login-form-error" *ngIf="formControls.email.errors&&formControls.email.errors.InvalidCred!=null">{{ 'incorrectemailorpasswordmsg' | translate }}</div>
        <div *ngIf="formControls.hiddenValidation.errors&&formControls.hiddenValidation.errors.Default!=null">{{formControls.hiddenValidation.errors.Default}}</div>
      </div>
      <div class="form-group" [ngClass]="{ 'has-error': isSubmitted && formControls.email.errors }">
        <label>{{ 'Email' | translate }}</label>
        <input class="form-control" type="email" placeholder="{{ 'Email' | translate }}" formControlName="email" (change)="onEmailChange()">
        <div *ngIf="isSubmitted && formControls.email.errors" class="required">
          <div *ngIf="formControls.email.errors.required"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div></div>
          <div *ngIf="formControls.email.errors.email!=null"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'InvalidEmailAddress' | translate }}</div></div>
          <div *ngIf="formControls.email.errors.UserNotExist!=null"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'UserNotExist' | translate }}</div></div>
          <div *ngIf="formControls.email.errors.AccountLockout!=null"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'AccountLockout' | translate }}</div></div>
        </div>
      </div>

      <div class="form-group" [ngClass]="{ 'has-error': isSubmitted && formControls.password.errors }">
        <label>{{ 'Password' | translate }}</label>

        <div class="input-group change-pass-input">
          <input [type]="hide ?   'text' :'password' " class="form-control" type="password" placeholder="{{ 'Password' | translate }}" formControlName="password" (blur)="onPasswordChange()">
          <div class="input-group-append">
            <span class="input-group-text"><mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon></span>
          </div>
        </div>


        <div *ngIf="isSubmitted && formControls.password.errors" class="required">
          <div *ngIf="formControls.password.errors.required"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div></div>
        </div>
      </div>

      <div class="form-group">
        <a class="text-blue d-table mt-1" (click)="ForgotYourPassword()" >{{ 'ForgotYourPassword' | translate }}</a>
      </div>



      <div class="text-center">
        <button type="submit" class="btn login-btn">{{ 'Login' | translate }}</button>
      </div>

    </form>

    <div class="login-external">
      <p> {{ 'OrLoginThrough' | translate }} <a href="#"><img src='assets/img/facbookLogin.svg' /></a> <a href="#"><img src='assets/img/googleLogin.svg' /></a></p>
      <!-- <p>I dont have an account, <a routerLink="/register" >REGISTER</a></p> -->
      <p>{{ 'IDontHaveAnAccount' | translate }}, <a [routerLink]="" (click)="register()" >{{ 'Register' | translate }}</a></p>
    </div>

</div>
<!-- /login form -->

<!-- Forgot Password form -->
<div  *ngIf="formMode==formModeType.ForgotPassword" class="login-form forgot-password">

  <div class="text-center mb-3">
    <h1>{{ 'RecoverPassword' | translate }}</h1>
  </div>

  <form [formGroup]="RecoverPasswordForm" class="login-container text-left" (ngSubmit)="onSubmitRecoverPassword()">

    <div class="form-group">
      <label for="email">{{ 'Email' | translate }}</label>
      <input placeholder="{{ 'Pleasedefineyourregisteredemailaddress' | translate }}" (blur)="emilBlur($event)"  type="text" class="form-control" formControlName="email" [ngClass]="{'is-invalid':RecoverPasswordForm.get('email').touched && RecoverPasswordForm.get('email').invalid}" required   />
      <div *ngIf="RecoverPasswordForm.get('email').touched && RecoverPasswordForm.get('email').invalid"  class="invalid-feedback">
        <div *ngIf="RecoverPasswordForm.get('email').invalid && RecoverPasswordForm.get('email').errors.required"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{'EmailNameisrequired'| translate}}</div>
        <div *ngIf="RecoverPasswordForm.get('email').errors.email||RecoverPasswordForm.get('email').errors.pattern"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{'Youhaveenteredaninvalide-mailaddress,pleasetryagain'| translate}}</div>
        <div *ngIf="RecoverPasswordForm.get('email').errors.somethingWentWrong"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{'SomethingWentWrong'| translate}}</div>
        <div *ngIf="RecoverPasswordForm.get('email').errors.notExist"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{'Emailisnotexist'| translate}}</div>

      </div>




    </div>

    <div class="text-center">
      <button type="submit" class="btn login-btn">{{ 'ResetPassword' | translate }}</button>
    </div>

    <div class="form-group text-center  mt-3">
      <a class="text-default reset-agian" (click)="showLogin()" >{{ 'BackToLogin' | translate }}</a>
    </div>

  </form>


</div>
<!-- /Forgot Password form -->


<!-- Forgot Password form -->
<div  *ngIf="formMode==formModeType.ResetSuccessfulySent" class="login-form sent-successfully">

  <mat-icon>check_circle_outline</mat-icon>
  <div class="text-center mb-3">
    <h1 class="text-blue">{{ 'SentSuccessfully' | translate }}</h1>
  </div>
  <p class="text-muted"> {{ 'ResetLinkhasbeensent,pleasecheckyouremailtorecoveryourforgottenpassword' | translate }}</p>
  <p> {{ 'Didntreciveemail' | translate }}, <a class="reset-agian" (click)="ForgotYourPassword()">{{ 'Resetagain' | translate }}</a> </p>
  <p><a class="reset-agian"  (click)="showLogin()" >{{ 'BackToLogin' | translate }}</a></p>
</div>
<!-- /Forgot Password form -->

